import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AUTOMATION_RUN_KEY } from '@/utils/queryKeys.ts';
import { AxiosError } from 'axios';
import { get_run_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import useRunId from '@/hooks/useRunId';
import { Run } from '@/types/runs.ts';

const useRetrieveRun = (
  providedRunId?: string,
  enabled: boolean | undefined = true,
): UseQueryResult<Run, AxiosError> => {
  const apiClient = useApiClient();
  const detectedRunId = useRunId();
  const automationId = useAutomationId();

  const runId = providedRunId || detectedRunId;

  return useQuery({
    queryKey: AUTOMATION_RUN_KEY(automationId, runId),
    queryFn: async () => {
      const response = await apiClient.get(get_run_url(runId));
      return response.data;
    },
    enabled: !!runId && enabled,
  });
};

export default useRetrieveRun;
